<template>
    <div class="container">
        <div>
            <h2 class="font-weight-bolder">Patient Report</h2>
        </div>
        <div class="search-heading mt-3">SEARCH</div>
        <div class="mt-1">
            <b-form v-on:submit.prevent="searchUsers" class="d-flex flex-column flex-md-row">
                <b-input-group :class="{'w-40': screen > 768, 'w-100': screen <= 768, 'border-inp border-dark rounded': true}">
                    <b-form-input class="py-4 border-0 no-outline" v-model="searchQuery"></b-form-input>
                    <b-input-group-append>
                        <b-button class="bg-white btn border-0 no-outline text-gray px-4 btn-hover">
                            <b-icon-search @click="searchUsers"></b-icon-search>
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
             <b-button class="clear-btn ml-0 ml-md-2 mt-2 mt-md-0  " @click="clearfilter()">Clear</b-button>
            </b-form>
        </div>

        <div class="container">
            <div class="row name-header mt-4 mb-3 p-2">
                <template v-if="screen > 425">
                    <div class="col-1">
                    </div>
                    <div class="col-3 text-uppercase">
                        Name
                    </div>
                    <div class="col-5 text-uppercase">
                        Email
                    </div>
                    <div class="col-2">
                    </div>
                </template>
                <div v-else class="px-2 text-uppercase">
                    User Info
                </div>
            </div>
        </div>

        <div v-if="patientArray.length >= 1 && !(patientArray[0]).message">
            <b-card class="mt-3 no-shadow" no-body v-for="(item, index) in patientArray" :key="index">
                <div class="ball" :style="[SetIfChecked(index) && {display: 'none'}]"></div>
                <b-card-header header-tag="header" class="border-0 bg-lgray" role="tab">
                    <b-row class="px-2" block  style="color: black;" @click="toggleArrow(index, item)">
                        <div :class="{'col-sm-1 d-flex justify-content-start align-items-center': true, 'mb-2': screen <= 425}">
                            <b-icon-chevron-down v-if="index == arrowToggled"></b-icon-chevron-down>
                            <b-icon-chevron-right v-else></b-icon-chevron-right>
                        </div>
                        <div class="col-md-3 col-sm-1 d-flex justify-content-start align-items-center text-truncate notranslate">
                            {{ item.name }}
                        </div>
                        <div class="col-md-4 col-sm-1 d-flex justify-content-start align-items-center text-truncate notranslate">
                            {{ item.email }}
                        </div>
                        <div class="col-4 d-flex justify-content-center" v-if="screen > 768">
                            <b-button class="shadow w-80 h-100 p-2 btn btn-outline-success ef-btn ef-btn-banner" :style="[index == arrowToggled ? {opacity: 1, 'pointer-events': 'all'} : {opacity: 0, 'pointer-events': 'none'}]" @click="Clickedbtn(item)" :disabled="validated()">Generate
                                Report</b-button>
                        </div>
                    </b-row>

                </b-card-header>
                <b-collapse :id="'accordion-' + index" accordion="my-accordion" role="tabpanel" :visible="index == arrowToggled">
                    <b-card-body>
                        <b-row class="mb-4">
                            <b-col cols=12 md=auto class="mt-2">
                                <div class="d-flex flex-row align-items-center">
                                    <div class="w-100">
                                        <div class="font-weight-bold mb-2">
                                            Start Date:
                                        </div>
                                        <b-form-datepicker :date-format-options="dateFormatOption" :min="minFromDate"
                                            :max="maxFromDate" class="filter-date-input-white notranslate" :id="'fromDate'+index" type="date"
                                            v-model="fromDate" :key="fromDate.toString()">
                                        </b-form-datepicker>
                                    </div>
                                </div>
                            </b-col>

                            <b-col cols=12 md=auto class="mt-2">
                                <div class="d-flex flex-row align-items-center">
                                    <div class="w-100">
                                        <div class="font-weight-bold mb-2">
                                            End Date:
                                        </div>
                                        <b-form-datepicker :date-format-options="dateFormatOption" :min="minToDate"
                                            :max="maxToDate" class="filter-date-input-white notranslate" :id="'toDate'+index" type="date"
                                            v-model="toDate" :key="toDate.toString()">
                                        </b-form-datepicker>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <div v-if="checkboxArray.length === 1 && checkboxArray[0].message" 
                        :key="checkboxArray.length === 1 ? checkboxArray[0].message : 'Loading Reports...'">{{ checkboxArray[0].message }}</div>
                        <b-row class="mb-3" v-if="checkboxArray.length >= 1 && !checkboxArray[0].message">
                            <div class="col-lg-3 col-md-6 font-weight-bold">
                                Select Program
                            </div>
                            <!-- <div class="col-6">
                                <b-form-checkbox :id="'select-all'+index" v-model="selectAll.checked" name="select-all"
                                @change="toggleAllCheckboxes()">
                                    {{ selectAll.label }}
                                </b-form-checkbox>
                            </div> -->
                        </b-row>

                        <div class="d-flex flex-column">
                          <div class="d-flex justify-content-between" v-for="(checkbox, ind) in checkboxArray">
                            <b-form-checkbox v-if="checkboxArray.length >= 1 && !checkboxArray[0].message" :key="'Checkboxes'+ind"
                                             v-model="checkbox.checked" @click.native="Clickedtoggle(ind)">
                            <span :style="[checkbox.is_active ? {'color' : '#28a745', 'font-weight' : 'bold'} : {}]" class="notranslate">  {{ checkbox.label }} </span>
                            </b-form-checkbox>
                            <b-button class="mr-2 edit-plan" v-if="checkbox.is_active" :variant="checkbox.is_active ?'primary' : 'secondary'" @click="editPlan(checkbox.treatment_plan_id)">Edit</b-button>
                          </div>
                        </div>

                        <div class="w-100"  v-if="screen <= 768">
                            <b-button class="btn btn-outline-success ef-btn ef-btn-banner mt-4"  @click="Clickedbtn(item)" :disabled="validated()">Generate
                                Report</b-button>
                        </div>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <p class="text-gray mt-1 p-1 page-num text-uppercase"> page {{ page }} of {{ maxpage }} ( Total: {{ totalPeople }} )</p>
        </div>

        <div v-else>
            <div class="p-2 w-full" :key=" patientArray.length >= 1 ? (patientArray[0]).message :'Loading...' ">
                {{ patientArray.length >= 1 ? (patientArray[0]).message : "Loading..." }}
            </div>
        </div>

        <nav aria-label="Page navigation example" v-if="maxpage != 0">
            <ul class="d-flex flex-row mt-3">
                <li role="button" class="page-item page-link px-4 fs-3 pe-auto" @click="prevPage()" v-if="maxpage > 1">Prev</li>
                <li class="page-item border bg-white px-2 text-center btn-width fs-3 pe-none" v-if="pageList[0] > 1">...</li>
                <li role="button" :class="['page-item page-link text-center btn-width fs-3 pe-auto', ind == page && 'selectedPage']" v-for="ind in pageList" @click.prevent="setPage(ind)">{{ind}}</li>
                <li class="page-item border bg-white px-2 text-center btn-width fs-3 pe-none" v-if="pageList[pageList.length-1] < maxpage">...</li>
                <li role="button" class="page-item page-link px-4 fs-3" @click="nextPage()" v-if="maxpage > 1">Next</li>
            </ul>
        </nav>

    </div>
</template>

<script>
import API from "@/module_dashboard/api.js";
import { IoTThingsGraph } from "aws-sdk";
export default {
    data() {
        return {
            searchQuery: null,
            maxFromDate: undefined,
            minFromDate: undefined,
            maxToDate: undefined,
            minToDate: undefined,
            fromDate: '',
            toDate: '',
            dateFormatOption: { year: 'numeric', month: 'short', day: '2-digit' },
            selectedUserDate: -1,
            arrowToggled: null,
            selectAll: {label: "Select All", checked: false},
            selectedCheckboxes: [],
            checkboxArray: [],
            patientArray: [],
            page: 1,
            numofpage: 15,
            maxpage: 0,
            totalPeople: 0,
            pageList: [],
            screen: 0,
            prevRoute : null
        }
    },
    methods: {
        clearfilter(){
            if(this.searchQuery == null)
                return 
            this.searchQuery=null
            this.page = 1
            this.searchUsers()
        },
        editPlan(planId) {
          this.$router.push({
            name: "CreateAssignProgram",
            params: {
              id: planId
            },
            query: {
              returnTo: encodeURIComponent(this.$route.fullPath)
            }
          })
        },
        async toggleArrow(index, user ) {
            if(this.selectedUserDate === -1) this.selectedUserDate = index
            if (this.arrowToggled == index){ 
                this.arrowToggled = null;
                if(this.checkboxArray.length === 0) this.getProgramDetails({userId : user.user_id})
            }
            else{ 
                this.arrowToggled = index;
                this.getProgramDetails({userId : user.user_id})
            }
            if(this.selectedUserDate !== index){
                this.selectedUserDate = index
                this.clearDates()
            }
        },

        SetIfChecked(index) {
            let ret = true;
            if(this.checkboxArray.length != 0 && this.selectedUserDate === index){
                for(let i = 0; i < this.checkboxArray.length; i++){
                    if(this.checkboxArray[i].checked === true){
                        ret = ret && false;
                    }
                }
            }
            return ret
        },

        searchUsers() {
            this.page = 1
            let params = this.searchQuery ? { page: this.page, search: this.searchQuery } : { page: this.page };
            this.arrowToggled = null;
            this.getUserList(params, true);
        },

        toggleAllCheckboxes() {
            const selectAllState = this.selectAll.checked;
            for(let i=0; i<this.checkboxArray.length; i++){
                this.checkboxArray[i].checked = selectAllState;
            }
        },

        arrayFill(start, end) {
            this.pageList = []
            for(let i = start; i <= end && i <= this.maxpage; i++){
                this.pageList.push(i)
            }
        },

        async getUserList(params, ref) {
            try {
                let response = await API.userList({...params, search: this.searchQuery });
                this.maxpage = response.data.data.totalPage;
                this.totalPeople = response.data.data.total;
                if(this.pageList.length === 0 || ref){
                    this.arrayFill(1, this.numofpage)
                }
                this.patientArray = [];
                if(this.maxpage == 0) this.patientArray.push({
                    message: "No User Found"
                })

                response.data.data.users.forEach((user) => {
                    if(!user.first_name + !user.last_name){
                        if(!user.email){
                            this.patientArray.push({
                                name: "User_"+user.user_id,
                                email: "Not entered",
                                user_id : user.user_id
                            })
                        }
                        else{
                            this.patientArray.push({
                                name: ((((user.email).split("@"))[0]).charAt(0).toUpperCase() + (((user.email).split("@"))[0]).slice(1)),
                                email: user.email,
                                user_id : user.user_id
                            })
                        }
                    }
                    else{
                        this.patientArray.push({
                            name: user.first_name + " " + user.last_name,
                            email: user.email,  
                            user_id : user.user_id
                        })
                    }
                })

            }
            catch (error) {
                console.log("There is an error in getting users' list: ", error);
            }
        },

        async getProgramDetails(params) {
            try {
                this.checkboxArray = [{message: "Loading Data..."}];
                let response = await API.getPatientsTreatmentPlans(params.userId);
                this.checkboxArray = []
                
                this.selectAll.checked = false;
                if(response.data.data.length === 0){
                    this.checkboxArray = [{message: "No treatment plans assigned to this user."}];
                    return;
                }
                response.data.data.forEach((item) => {
                    this.checkboxArray.push({
                        label: item.treatment_name,
                        start: item.start_date,
                        end: item.end_date,
                        checked: false,
                        assign_id : item.treatment_plan_assign_id,
                        treatment_plan_id : item.treatment_plan_id,
                        is_active: item.is_active
                    })
                })
                
            }
                catch(error) {
                console.log("There is an error in getting program details: ", error);
            }
        },

        async nextPage() {
            if(this.page < this.maxpage){
                this.getUserList({ page: ++this.page }, false);
                this.arrowToggled = null
            }
            if(this.page == this.pageList[this.pageList.length-1]+1 && this.page <= this.maxpage){
                if(this.page - this.numofpage + 1 > 1){
                    this.numofpage = 14
                    if(this.screen <= 768){
                        this.numofpage = 6
                    }
                    if(this.screen <= 425){
                        this.numofpage = 3
                    }
                }
                this.arrayFill(this.page - this.numofpage, this.page)
            }
        },

        async prevPage() {
            if(this.page > 1) {this.getUserList({ page: --this.page }, false);
            this.arrowToggled = null
        
        }
            if(this.page == this.pageList[0]-1 && this.page >= 1){
                if(this.page+this.numofpage-1 < this.maxpage){
                    this.numofpage = 14
                    if(this.screen <= 768){
                        this.numofpage = 6
                    }
                    if(this.screen <= 425){
                        this.numofpage = 3
                    }
                }
                this.arrayFill(this.page, this.page+this.numofpage)
            }
        },

        async setPage(ind) {
            this.page = ind
            this.getUserList({ page: ind }, false);
            this.arrowToggled = null

        },

        Clickedbtn(user){
            localStorage.setItem('patientReport', JSON.stringify({
                searchQuery : this.searchQuery,
                checkboxArray : this.checkboxArray,
                patientArray : this.patientArray,
                selectedCheckboxes : this.selectedCheckboxes,
                selectedUserDate : this.selectedUserDate,
                arrowToggled : this.arrowToggled,
                page : this.page,
                numofpage : this.numofpage,
                maxpage : this.maxpage
            }))

            const selectedTreatmentPlanIds = this.checkboxArray.filter(plan=> plan.checked)
            .map(filteredPlan=> filteredPlan.assign_id)
           
            const query = {
                userId : user.user_id,
                assignId : JSON.stringify(selectedTreatmentPlanIds),
            };

            if(new Date(this.fromDate) != 'Invalid Date' && this.fromDate != "" ){
                query.startDate = this.fromDate
            }

            if(new Date(this.toDate) != 'Invalid Date' && this.fromDate != "" ){
                query.endDate = this.toDate
            }

            try{
                this.$router.push({ path: 'patient-report-details',  query : query });
            } catch(error){
                console.log("There is an error in getting program details: ", error)
            }
        },

        // Not Need to use
        selectCheckBoxDate(){
            let selectedall = true
            if(new Date(this.fromDate) != 'Invalid Date' && new Date(this.toDate) != 'Invalid Date'){
                this.checkboxArray.map((ele, ind) => {
                    if(new Date(ele.start) >= new Date(this.fromDate) && new Date(ele.end) <= new Date(this.toDate)){
                        this.checkboxArray[ind].checked = true
                        selectedall = selectedall && true;
                    }else{
                        this.checkboxArray[ind].checked = false
                        selectedall = selectedall && false;
                    }
                })
                this.selectAll.checked = selectedall
            }else if(new Date(this.fromDate) != 'Invalid Date'){
                this.checkboxArray.map((ele, ind) => {
                    if(new Date(ele.start) >= new Date(this.fromDate)){
                        this.checkboxArray[ind].checked = true
                        selectedall = selectedall && true;
                    }else{
                        this.checkboxArray[ind].checked = false
                        selectedall = selectedall && false;
                    }
                })
                this.selectAll.checked = selectedall
            }else{
                this.checkboxArray.map((ele, ind) => {
                    if(new Date(ele.end) <= new Date(this.toDate)){
                        this.checkboxArray[ind].checked = true
                        selectedall = selectedall && true;
                    }else{
                        this.checkboxArray[ind].checked = false
                        selectedall = selectedall && false;
                    }
                })
                this.selectAll.checked = selectedall
            }
        },

        clearDates(){
            this.toDate = '';
            this.fromDate = '';
        },

        Clickedtoggle(ind){
            for(let i=0; i<this.checkboxArray.length; i++){
                if(i == ind) continue;
                this.checkboxArray[i].checked = false;
            }
        },

        validated(){
            let valid = true;
            this.checkboxArray.forEach((ele) => {
                valid = valid && !ele.checked
            })
            return valid
        },

        loadDataFromLocalStorage(){
            const data = JSON.parse(localStorage.getItem('patientReport') || JSON.stringify({}));
            this.searchQuery = data.searchQuery || null;
            this.checkboxArray = data.checkboxArray || [];
            this.patientArray = data.patientArray || [];
            this.arrowToggled = data.arrowToggled ;
            this.selectedUserDate = data.selectedUserDate || -1;
            this.selectedCheckboxes = data.selectedCheckboxes || []
            this.page = data.page || 1;
            this.numofpage = data.numofpage || 15;
            this.maxpage = data.maxpage || 0;    
            this.arrayFill(1, this.numofpage)

        }     

    },
    beforeRouteEnter(to, from, next) {
    next(vm => {
        vm.prevRoute = from
    })
},
    components: {
    },
    watch: {
        fromDate: function (val) {
            this.minToDate = new Date(val);  
        },
        toDate: function (val) {
            this.maxFromDate = new Date(val); 
        },
        prevRoute :async function(val){
            if (val?.path === "/management/analytics/patient-report-details") {
                this.loadDataFromLocalStorage();
            } else {
                this.getUserList({ page: this.page }, true);
            }
        },
        searchQuery : function(){
            if (this.searchTimeout){
                clearTimeout(this.searchTimeout)
                this.searchTimeout = null
            }
            const ctx = this;
            if(this.searchQuery != null){
                this.searchTimeout = setTimeout(()=>{
                    ctx.searchUsers()
                }, 500)
            }
        }
    },
    computed: {
    },
    async mounted() {
        this.screen = window.screen.width;
        if(this.screen <= 768){
            this.numofpage = 7
        }
        if(this.screen <= 425){
            this.numofpage = 4
        }
        window.addEventListener('resize', () => {
            this.screen = window.screen.width
        });
    },
}
</script>

<style lang="scss" scoped>
::v-deep .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
    background-color: #73bd45;
}

.search-heading {
    font-weight: bold;
    font-size: 1.2rem;
    color: #969B92;
}

.name-header {
    background-color: #d8f1b6;
    font-weight: bold;
    border-radius: 3px;
}

.name-col {
    padding-left: 100px;
}

.btn-width{
    width: 4rem;
}

.selectedPage{
    background-color: #d8f1b6;
}

.ef-btn {
    padding: 5px 10px;
    height: 34px;
    font-size: 14px;
    border-radius: 4px !important;
}

.no-shadow {
    box-shadow: none;
    border: 2px solid #969696;
}

.bg-lgray{
    background-color: #efefef;
}

.border-inp{
    border: 3px solid;
}

.btn-hover:hover{
    background-color: #d8f1b6;
    color: black;
}

.no-outline:focus{
    box-shadow: none !important;
}

.page-num{
    font-size: 0.8rem;
}

.ball{
    height: 10px;
    width: 10px;
    z-index: 3;
    position: absolute;
    left: -5px;
    border-radius: 50%;
    top: -5px;
    background-color: #73bc45;
}

.edit-plan {
  margin: 1px;
}

</style>
